import { render, staticRenderFns } from "./generaciones-snp.vue?vue&type=template&id=ee2d3a6c&"
import script from "./generaciones-snp.component.ts?vue&type=script&lang=ts&"
export * from "./generaciones-snp.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports